module.exports = __webpack_public_path__ + "static/media/bg_page45_main.9b441cb2.png";